import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { autoConfirmStop } from 'utils/actions/shipmentStop'

/**
 * @deprecated Please delete this file when mpNewSchedulerPage got turned on in prod
 */
export const DeprecatedFCFSButton = React.memo(({ stop }) => {
  const state = useSelector(({ schedule_stops: { submitting } }) => ({ submitting }))
  const { submitting } = state
  const dispatch = useDispatch()
  const { autoConfirmToken, endAtTime, startAtTime, stopId } = stop
  const confirmStop = () => {
    dispatch(autoConfirmStop(stopId, autoConfirmToken, startAtTime, endAtTime))
  }
  const key = `${stop.stopId}-fcfs`
  return (
    <button
      className='btn-primary'
      onClick={confirmStop}
      key={key}
      data-test={key}
      disabled={submitting}>
      Yes, confirm {startAtTime} - {endAtTime}
    </button>
  )
})

DeprecatedFCFSButton.propTypes = {
  stop: PropTypes.shape({}).isRequired,
}
